export function headingFromData(data, idx, defaultHeading) {
    const headers = data && data.header && data.header.headers;
    return headers[idx] || defaultHeading;
}